
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/faq",
      function () {
        return require("private-next-pages/landing/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/faq"])
      });
    }
  